var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMercleBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 20,
    viewBox: "0 0 78 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_4108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 16
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_127_731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M78.0002 0.779297H0V15.221H78.0002V0.779297Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_4108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.80711 0.779297V6.8621H5.00391V0.779297H8.80711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4577 3.63721V7.65475H-0.000488281V3.63721H12.4577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.98251 6.67773C10.1978 8.04033 12.4587 11.2272 12.4587 14.9334H8.44117C8.44117 12.9838 7.30626 11.2939 5.6626 10.4889",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.96042 5.97168H4.94287C4.94287 8.69778 2.72464 10.916 -0.00146484 10.916V14.9336C4.93931 14.9336 8.95953 10.9142 8.95953 5.97256L8.96042 5.97168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M68.9592 10.0585L75.5898 7.90426C74.8854 6.24014 72.9456 5.50103 71.2975 6.03647C69.7232 6.54789 68.5456 8.2796 68.9592 10.0585ZM77.9335 8.75367L69.4324 11.5162C70.4214 13.0478 72.1229 13.6829 73.6972 13.1715C74.9006 12.7801 75.8291 11.7937 76.0728 10.5263L77.9993 9.90017C77.8775 12.2358 76.3895 14.2095 74.1855 14.9254C71.2966 15.8638 68.1463 14.1089 67.2702 11.413C66.2349 8.22535 67.9568 5.20841 70.6793 4.32431C73.6981 3.34327 76.7408 4.89267 77.6809 7.78864C77.7815 8.09816 77.8766 8.38989 77.9335 8.75367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M65.7585 14.9523H63.7671V0.779297H65.7585V14.9523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M60.5646 11.4475H62.7864C61.9432 13.8419 59.9136 15.2205 57.5574 15.2205C54.512 15.2205 52.1177 12.7692 52.1177 9.7425C52.1177 6.54411 54.4356 4.05371 57.5379 4.05371C59.9509 4.05371 62.154 5.56663 62.7864 7.86492H60.5842C59.99 6.61971 59.0321 5.87259 57.5957 5.87259C55.5082 5.87259 54.11 7.46201 54.11 9.62687C54.11 11.7917 55.5464 13.3999 57.5574 13.3999C58.9173 13.3999 60.0087 12.6723 60.5646 11.4466V11.4475Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M48.9381 14.9528H46.9458V4.34189H48.8038V5.22865C48.8038 5.24377 48.8154 5.25533 48.8305 5.25533C48.8376 5.25533 48.8447 5.25266 48.85 5.24644C49.727 4.31698 50.8744 4.05371 52.2975 4.05371V6.10295C50.3807 6.10295 48.9372 6.39824 48.9372 8.99537V14.9519L48.9381 14.9528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M37.0083 10.0699L43.5296 7.95126C42.8278 6.28625 40.9129 5.53913 39.2923 6.06567C37.7439 6.56909 36.5912 8.29191 37.0083 10.0699ZM45.843 8.81045L37.4824 11.5268C38.4643 13.0601 40.1427 13.7032 41.6912 13.1998C42.875 12.8146 43.7849 11.8345 44.0188 10.5707L45.9133 9.95517C45.8048 12.2863 44.3479 14.2493 42.1803 14.9537C39.3387 15.877 36.2266 14.1088 35.3513 11.4129C34.3151 8.2252 35.9979 5.2216 38.6761 4.35174C41.6449 3.38672 44.6494 4.94854 45.5904 7.84453C45.6909 8.15405 45.7861 8.44578 45.8439 8.80956L45.843 8.81045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.7272 14.9719H16.6797L20.0755 5.99047C20.4989 4.75773 21.1988 3.99193 22.662 3.99193C24.2887 3.99193 25.1008 4.93561 25.1008 6.34002V12.7172C25.1008 13.0846 25.3293 13.323 25.6522 13.323C25.9457 13.323 26.1735 13.1477 26.2686 12.8746L28.9351 5.9878C29.3585 4.75861 30.0549 3.98926 31.5188 3.98926C33.1456 3.98926 33.9577 4.93294 33.9577 6.33735V14.9666H32.0232V6.43519C32.0232 6.05096 31.7946 5.8117 31.4691 5.8117C31.1934 5.8117 30.9656 6.00381 30.8678 6.27509L28.2013 13.1619C27.7779 14.3911 27.0638 15.1605 25.5998 15.1605C23.9908 15.1605 23.1787 14.2168 23.1787 12.7946V6.43519C23.1787 6.05096 22.9359 5.8117 22.6095 5.8117C22.316 5.8117 22.1203 6.00381 22.0082 6.27509L18.7253 14.9684L18.7281 14.971L18.7272 14.9719Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercleBlack);
export default __webpack_public_path__ + "static/media/mercle_black.63c4401c911e490e3bf4a5dd7a93411c.svg";
export { ForwardRef as ReactComponent };